namespace GeniuzPOS.ReportMasterData {
    export interface Report_1334Form {
    }

    export class Report_1334Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1334';
    }
}
